import React from 'react';
import Tooltip from 'components/styleguide/tooltip/Tooltip';

const styles = require('./addon_info_tooltip.module.scss');

export default function AddonInfoTooltip({ text }: { text: string }) {
  return (
    <Tooltip
      triggerAriaLabel="More info"
      wrapperClassName={styles.wrapper}
      popoverClassName={styles.popover}
      stopPropagation
    >
      {text}
    </Tooltip>
  );
}
